var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 27,
    viewBox: "0 0 12 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.277 8.755a1.428 1.428 0 1 1 2.855 0 1.428 1.428 0 0 1-2.855 0zM4.277 13.554a1.428 1.428 0 1 1 2.855 0 1.428 1.428 0 0 1-2.855 0zM4.277 18.353a1.428 1.428 0 1 1 2.855 0 1.428 1.428 0 0 1-2.855 0z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ea826fc07bf980b091c23909ede80c70.svg";
export { ForwardRef as ReactComponent };